// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"eb47935b","667":"92488470","977":"830c08f4"}[chunkId] + ".chunk.js";
};